export var getSupervisorInfo = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, fullName = _a.fullName, image = _a.image, id = _a.id;
    return ({ firstName: firstName, lastName: lastName, fullName: fullName, imagePath: image === null || image === void 0 ? void 0 : image.fullPath, id: id });
};
